export default {
    getCategoriest() {
        const categories =
            [
                {
                    id: 1,
                    avatar: "technologyOption.jpeg",
                    categorylist: [
                        {
                            id: 1,
                            title: "Solar"
                        },
                        {
                            id: 2,
                            title: "Solar plus energy storage"
                        },
                        {
                            id: 3,
                            title: "Energy storage"
                        }
                    ],
                    method: "Technology Options",
                    color:"#60B454"
                },
                {
                    id: 2,
                    avatar: "powerflowsimulation.jpeg",
                    categorylist: [
                        {
                            id: 1,
                            title: "Active power"
                        },
                        {
                            id: 2,
                            title: "Voltage"
                        }
                    ],
                    method: "Power Flow Simulation",
                    color:"#55AE79"
                },
                {
                    id: 3,
                    avatar: "distributionEnergy.jpeg",
                    categorylist: [
                        {
                            id: 1,
                            title: "Avoided network costs"
                        },
                        {
                            id: 2,
                            title: "Avoid social costs"
                        },
                        {
                            id: 3,
                            title: "Avoid environmental costs"
                        },
                    ],
                    method: "Value of distributed energy sources",
                    color:"#43A998"
                },
            ]
        return categories
    },

    getResources() {
        const resources = [
            {
                id: 1,
                title: "Network benefits",
                avatar: "networkBenefits.jpeg",
                color:"#34a4b5",
                benfts: [
                    "Avoided cost of energy (ACE)",
                    "Avoided transmission capacity costs (ATCC)",
                    "Avoided distribution capacity cost (ADCC)",
                    "Avoided generation capacity cost (AGCC)"
                ]
            },
            {
                id: 2,
                title: "Environmental and Societal benefits",
                avatar: "societalBenefits.jpeg",
                color:"#1ba0d3",
                benfts: [
                    "Avoided CO2 emission costs",
                    "Avoided SO2 emission costs",
                    "Avoided NO2 emission costs",
                    "Avoided PM2.5 emission costs"
                ]
            },
        ]
        return resources
    },
    getUsefullLinks(){
      const  usefullLinks=[
            {
              text:"Auroville Consulting",
              icon: "mdi-facebook",
              link: "https://www.aurovilleconsulting.com",
            },
            {
              text:"Auroville Green Practices",
              icon: "mdi-facebook",
              link: "https://www.agpworkshops.com",
            },
            {
              text:"Solsavi",
              icon: "mdi-facebook",
              link: "https://www.solsavi.in",
            },
             {
              text:"Carbon Converter",
              icon: "mdi-facebook",
              link: "https://carbonconverter.org",
            },
            //  {
            //   text:"Solse",
            //   icon: "mdi-facebook",
            //   link: "https://www.solse.org",
            // },
            {
                text:"Lila",
                icon: "mdi-facebook",
                link: "https://www.thelila.org",
              }
          ]
          return usefullLinks;
    },
    getLinks(){
       const links= ["About us", "Contact Us", "Useful Links", "Disclaimer"]
        return links
    },
    getSocialMedia(){
        const socialMedia= [
            {
              icon: "mdi-facebook",
              link: "https://www.facebook.com/AurovilleConsulting",
            },
            {
              icon: "mdi-twitter",
              link: "https://twitter.com/AVCsustainable?t=C-oBplLv_0-QzmrIXeuBGQ&s=08",
            },
            {
              icon: "mdi-youtube",
              link: "https://www.youtube.com/channel/UCBAU_XEu9GnTSnsBO4ySbPg",
            },
            {
              icon: "mdi-linkedin",
              link: "https://www.linkedin.com/company/auroville-consulting/",
            },
            {
              icon: "mdi-instagram",
              link: "https://www.instagram.com/accounts/login/?next=/aurovilleconsulting/",
            },
          ]
          return socialMedia
    }

}